import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.lpsysadmin.widget.notion.editor');
import { OnInit, Input, Output, EventEmitter, OnDestroy, OnChanges, SimpleChanges } from '@angular/core';
import { ElementRef, ViewChild, ChangeDetectorRef } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { createNotionEditor, SLASH_MENU_ITEMS, SlashMenuItem, TEXT_COLORS, BG_COLORS, TURN_INTO_ITEMS, TurnIntoItem } from "src/libs/portal/lpsysadmin/tiptap";
import { Editor } from '@tiptap/core';

@Component({
    selector: 'wiz-portal-lpsysadmin-widget-notion-editor',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.lpsysadmin.widget.notion.editor/view.scss */
/* src/app/portal.lpsysadmin.widget.notion.editor/view.scss: no such file or directory */`],
})
export class PortalLpsysadminWidgetNotionEditorComponent implements OnInit, OnDestroy, OnChanges {
    @ViewChild('editorContainer') editorContainer: ElementRef;

    @Input() content: any = null;
    @Input() editable: boolean = true;
    @Input() placeholder: string = '';

    @Output() contentChange = new EventEmitter<any>();

    public editor: Editor | null = null;

    // Fixed toolbar state
    public toolbarVisible = false;
    public toolbarColorPickerOpen = false;
    public toolbarColorPickerMode: 'text' | 'bg' = 'text';
    public toolbarHeadingOpen = false;
    public toolbarInsertOpen = false;

    // Slash command menu state
    public slashMenuOpen = false;
    public slashMenuItems: SlashMenuItem[] = [];
    public slashFilteredItems: SlashMenuItem[] = [];
    public slashQuery = '';
    public slashMenuPos = { top: 0, left: 0 };
    public slashSelectedIndex = 0;
    private slashRange: any = null;

    // Bubble menu state
    public bubbleMenuOpen = false;
    public bubbleMenuPos = { top: 0, left: 0 };

    // Color picker state
    public colorPickerOpen = false;
    public colorPickerMode: 'text' | 'bg' = 'text';
    public textColors = TEXT_COLORS;
    public bgColors = BG_COLORS;

    // Table toolbar state
    public tableMenuOpen = false;
    public tableMenuPos = { top: 0, left: 0 };

    // Block menu state (turn-into in bubble menu)
    public blockMenuOpen = false;
    public blockMenuMode: 'add' | 'turninto' = 'add';
    public turnIntoItems: TurnIntoItem[] = TURN_INTO_ITEMS;

    // Block handle state (Angular-managed)
    public blockHandleVisible = false;
    public blockHandleTop = 0;
    public blockHandleHovered = false;
    private hoveredBlockPos: number | null = null;

    // Link input state
    public linkInputOpen = false;
    public linkInputUrl = '';

    // Table grid picker state
    public tableGridPickerOpen = false;
    public tableGridHoverRow = 0;
    public tableGridHoverCol = 0;
    public gridSizes = [1, 2, 3, 4, 5, 6];

    // Image paste handler reference
    private imagePasteHandler: ((e: Event) => void) | null = null;

    constructor(@Inject( Service) public service: Service,@Inject( ChangeDetectorRef)  private cdr: ChangeDetectorRef) { }

    public async ngOnInit() {
        await this.service.init();
        this.slashMenuItems = SLASH_MENU_ITEMS;
        this.slashFilteredItems = [...this.slashMenuItems];
        setTimeout(() => this.initEditor(), 0);
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['content'] && this.editor && !changes['content'].firstChange) {
            const current = this.editor.getJSON();
            if (JSON.stringify(current) !== JSON.stringify(this.content)) {
                this.editor.commands.setContent(this.content);
            }
        }
        if (changes['editable'] && this.editor && !changes['editable'].firstChange) {
            this.editor.setEditable(this.editable);
        }
    }

    ngOnDestroy() {
        this.destroyEditor();
        document.removeEventListener('click', this.closeMenusHandler);
    }

    private closeMenusHandler = (e: Event) => {
        let changed = false;
        if (this.colorPickerOpen) {
            this.colorPickerOpen = false;
            changed = true;
        }
        if (this.blockMenuOpen) {
            const target = e.target as HTMLElement;
            if (!target.closest('.turn-into-dropdown') && !target.closest('.bubble-turninto-wrap')) {
                this.blockMenuOpen = false;
                changed = true;
            }
        }
        if (this.linkInputOpen) {
            const target = e.target as HTMLElement;
            if (!target.closest('.link-input-wrap')) {
                this.linkInputOpen = false;
                changed = true;
            }
        }
        // Close toolbar dropdowns
        if (this.toolbarColorPickerOpen || this.toolbarHeadingOpen || this.toolbarInsertOpen) {
            const target = e.target as HTMLElement;
            if (!target.closest('.toolbar-dropdown-wrap')) {
                this.toolbarColorPickerOpen = false;
                this.toolbarHeadingOpen = false;
                this.toolbarInsertOpen = false;
                changed = true;
            }
        }
        if (this.tableGridPickerOpen) {
            const target = e.target as HTMLElement;
            if (!target.closest('.table-grid-dropdown') && !target.closest('.toolbar-dropdown-wrap')) {
                this.tableGridPickerOpen = false;
                changed = true;
            }
        }
        if (changed) this.cdr.detectChanges();
    };

    private destroyEditor() {
        if (this.imagePasteHandler && this.editor) {
            this.editor.view.dom.removeEventListener('paste', this.imagePasteHandler, true);
            this.imagePasteHandler = null;
        }
        if (this.editor) {
            this.editor.destroy();
            this.editor = null;
        }
    }

    private initEditor() {
        const el = this.editorContainer?.nativeElement;
        if (!el) return;
        this.destroyEditor();

        const placeholderText = this.placeholder || (this.editable
            ? "'/' 를 입력하면 명령어를 사용할 수 있습니다."
            : '');

        const uploadImageFn = async (file: File): Promise<string | null> => {
            try {
                const fd = new FormData();
                fd.append('upload', file);
                const res: any = await this.service.file.upload('/file/upload', fd, () => { });
                return res?.url || null;
            } catch (e) {
                console.error('[notion-editor] Image upload failed:', e);
                return null;
            }
        };

        this.editor = createNotionEditor({
            element: el,
            content: this.content,
            editable: this.editable,
            placeholder: placeholderText,
            uploadImageFn: this.editable ? uploadImageFn : undefined,
            onUpdate: (json: any) => {
                this.contentChange.emit(json);
            },
            onCreate: (_editor: Editor) => { },
        });

        if (this.editable) {
            this.editor.on('update', () => {
                this.handleSlashDetection();
                this.checkTableContext();
            });
            this.editor.on('selectionUpdate', () => {
                this.handleBubbleMenu();
                this.checkTableContext();
            });
            this.editor.on('focus', () => {
                this.toolbarVisible = true;
                this.cdr.detectChanges();
            });
            this.editor.on('blur', ({ event }) => {
                // Don't hide if clicking on toolbar
                const related = event?.relatedTarget as HTMLElement;
                if (related?.closest('.editor-fixed-toolbar')) return;
                setTimeout(() => {
                    if (!this.editor?.isFocused) {
                        this.toolbarVisible = false;
                        this.toolbarColorPickerOpen = false;
                        this.toolbarHeadingOpen = false;
                        this.toolbarInsertOpen = false;
                        this.tableGridPickerOpen = false;
                        this.cdr.detectChanges();
                    }
                }, 150);
            });
            el.addEventListener('keydown', (e: KeyboardEvent) => this.handleSlashKeydown(e));
            document.addEventListener('click', this.closeMenusHandler);

            // Capture-phase paste handler for reliable Ctrl+V image paste
            this.imagePasteHandler = (e: Event) => {
                const ce = e as ClipboardEvent;
                if (!ce.clipboardData) return;

                // Check items first
                const items = ce.clipboardData.items;
                if (items) {
                    for (let i = 0; i < items.length; i++) {
                        if (items[i].type.startsWith('image/')) {
                            const file = items[i].getAsFile();
                            if (file) {
                                e.preventDefault();
                                e.stopImmediatePropagation();
                                this.pasteImageFile(file);
                                return;
                            }
                        }
                    }
                }

                // Fallback: check files collection (some browsers/OS put screenshots here)
                const files = ce.clipboardData.files;
                if (files && files.length > 0) {
                    for (let i = 0; i < files.length; i++) {
                        if (files[i].type.startsWith('image/')) {
                            e.preventDefault();
                            e.stopImmediatePropagation();
                            this.pasteImageFile(files[i]);
                            return;
                        }
                    }
                }
            };
            this.editor.view.dom.addEventListener('paste', this.imagePasteHandler, true);
        }
    }

    /* ────────────────────────────────────────
       Image Paste (Ctrl+V)
       ──────────────────────────────────────── */
    private async pasteImageFile(file: File) {
        if (!this.editor) return;
        try {
            const fd = new FormData();
            fd.append('upload', file);
            const res: any = await this.service.file.upload('/file/upload', fd, () => { });
            const url = res?.url;
            if (url && this.editor) {
                this.editor.chain().focus().setImage({ src: url }).run();
            }
        } catch (e) {
            console.error('[notion-editor] Image paste upload failed:', e);
        }
    }

    /* ────────────────────────────────────────
       Fixed Toolbar Actions
       ──────────────────────────────────────── */
    public toggleToolbarHeading(event: Event) {
        event.stopPropagation();
        this.toolbarHeadingOpen = !this.toolbarHeadingOpen;
        this.toolbarInsertOpen = false;
        this.toolbarColorPickerOpen = false;
        this.tableGridPickerOpen = false;
        this.cdr.detectChanges();
    }

    public toggleToolbarInsert(event: Event) {
        event.stopPropagation();
        this.toolbarInsertOpen = !this.toolbarInsertOpen;
        this.toolbarHeadingOpen = false;
        this.toolbarColorPickerOpen = false;
        this.tableGridPickerOpen = false;
        this.cdr.detectChanges();
    }

    public toggleToolbarColorPicker(event: Event, mode: 'text' | 'bg') {
        event.stopPropagation();
        if (this.toolbarColorPickerOpen && this.toolbarColorPickerMode === mode) {
            this.toolbarColorPickerOpen = false;
        } else {
            this.toolbarColorPickerMode = mode;
            this.toolbarColorPickerOpen = true;
        }
        this.toolbarHeadingOpen = false;
        this.toolbarInsertOpen = false;
        this.tableGridPickerOpen = false;
        this.cdr.detectChanges();
    }

    public toolbarSetHeading(level: number) {
        this.editor?.chain().focus().toggleHeading({ level: level as 1 | 2 | 3 }).run();
        this.toolbarHeadingOpen = false;
        this.cdr.detectChanges();
    }

    public toolbarSetParagraph() {
        this.editor?.chain().focus().setParagraph().run();
        this.toolbarHeadingOpen = false;
        this.cdr.detectChanges();
    }

    public openTableGridPicker() {
        this.toolbarInsertOpen = false;
        this.tableGridPickerOpen = true;
        this.tableGridHoverRow = 0;
        this.tableGridHoverCol = 0;
        this.cdr.detectChanges();
    }

    public insertTableFromGrid(rows: number, cols: number) {
        this.editor?.chain().focus().insertTable({ rows, cols, withHeaderRow: true }).run();
        this.tableGridPickerOpen = false;
        this.cdr.detectChanges();
    }

    public toolbarInsertHR() {
        this.editor?.chain().focus().setHorizontalRule().run();
        this.toolbarInsertOpen = false;
        this.cdr.detectChanges();
    }

    public toolbarInsertCodeBlock() {
        this.editor?.chain().focus().toggleCodeBlock().run();
        this.toolbarInsertOpen = false;
        this.cdr.detectChanges();
    }

    public toolbarInsertBlockquote() {
        this.editor?.chain().focus().toggleBlockquote().run();
        this.toolbarInsertOpen = false;
        this.cdr.detectChanges();
    }

    public toolbarInsertBulletList() {
        this.editor?.chain().focus().toggleBulletList().run();
        this.toolbarInsertOpen = false;
        this.cdr.detectChanges();
    }

    public toolbarInsertOrderedList() {
        this.editor?.chain().focus().toggleOrderedList().run();
        this.toolbarInsertOpen = false;
        this.cdr.detectChanges();
    }

    public toolbarInsertTaskList() {
        this.editor?.chain().focus().toggleTaskList().run();
        this.toolbarInsertOpen = false;
        this.cdr.detectChanges();
    }

    public toolbarSetTextColor(color: string | null) {
        if (!this.editor) return;
        if (color) {
            this.editor.chain().focus().setColor(color).run();
        } else {
            this.editor.chain().focus().unsetColor().run();
        }
        this.toolbarColorPickerOpen = false;
        this.cdr.detectChanges();
    }

    public toolbarSetBgColor(color: string | null) {
        if (!this.editor) return;
        if (color) {
            this.editor.chain().focus().toggleHighlight({ color }).run();
        } else {
            this.editor.chain().focus().unsetHighlight().run();
        }
        this.toolbarColorPickerOpen = false;
        this.cdr.detectChanges();
    }

    /* ────────────────────────────────────────
       Block Handle (Angular-managed)
       ──────────────────────────────────────── */
    public onEditorMouseMove(event: MouseEvent) {
        if (!this.editor || !this.editable) return;
        const view = this.editor.view;
        const editorRect = view.dom.getBoundingClientRect();
        const pos = view.posAtCoords({ left: editorRect.left + 10, top: event.clientY });
        if (!pos) {
            if (!this.blockHandleHovered) this.blockHandleVisible = false;
            return;
        }
        const resolvedPos = view.state.doc.resolve(pos.pos);
        if (resolvedPos.depth < 1) {
            if (!this.blockHandleHovered) this.blockHandleVisible = false;
            return;
        }
        const blockPos = resolvedPos.before(resolvedPos.depth);
        const domNode = view.nodeDOM(blockPos);
        if (!domNode || !(domNode instanceof HTMLElement)) {
            if (!this.blockHandleHovered) this.blockHandleVisible = false;
            return;
        }
        const nodeRect = domNode.getBoundingClientRect();
        const wrapperEl = this.editorContainer.nativeElement.closest('.notion-editor-wrapper');
        if (!wrapperEl) return;
        const wrapperRect = wrapperEl.getBoundingClientRect();
        this.hoveredBlockPos = blockPos;
        this.blockHandleTop = nodeRect.top - wrapperRect.top + 2;
        this.blockHandleVisible = true;
        this.cdr.detectChanges();
    }

    public onEditorMouseLeave() {
        if (!this.blockHandleHovered) {
            this.blockHandleVisible = false;
            this.cdr.detectChanges();
        }
    }

    public hideBlockHandle() {
        setTimeout(() => {
            if (!this.blockHandleHovered) {
                this.blockHandleVisible = false;
                this.cdr.detectChanges();
            }
        }, 100);
    }

    public handleAddBlockClick() {
        if (!this.editor || this.hoveredBlockPos === null) return;
        const resolvedPos = this.editor.state.doc.resolve(this.hoveredBlockPos);
        const nodeEnd = resolvedPos.end(resolvedPos.depth);
        this.editor.chain()
            .focus()
            .setTextSelection(nodeEnd)
            .splitBlock()
            .insertContent('/')
            .run();
        this.blockHandleVisible = false;
        this.cdr.detectChanges();
    }

    public selectTurnIntoItem(item: TurnIntoItem) {
        if (!this.editor) return;
        item.command(this.editor);
        this.blockMenuOpen = false;
        this.cdr.detectChanges();
    }

    public switchBlockMenuMode(mode: 'add' | 'turninto') {
        this.blockMenuMode = mode;
        this.cdr.detectChanges();
    }

    /* ────────────────────────────────────────
       Slash Command Menu
       ──────────────────────────────────────── */
    private handleSlashDetection() {
        if (!this.editor || !this.editable) return;
        const { state } = this.editor;
        const { $from } = state.selection;
        const textBefore = $from.parent.textContent.slice(0, $from.parentOffset);

        const slashMatch = textBefore.match(/\/([^\s]*)$/);
        if (slashMatch) {
            this.slashQuery = slashMatch[1];
            this.slashRange = {
                from: $from.pos - slashMatch[0].length,
                to: $from.pos,
            };
            this.filterSlashItems();
            this.updateSlashMenuPosition();
            this.slashMenuOpen = true;
            this.slashSelectedIndex = 0;
        } else {
            this.slashMenuOpen = false;
        }
        this.cdr.detectChanges();
    }

    private filterSlashItems() {
        const q = this.slashQuery.toLowerCase();
        this.slashFilteredItems = q
            ? this.slashMenuItems.filter(item =>
                item.title.toLowerCase().includes(q) ||
                item.description.toLowerCase().includes(q) ||
                (item.keywords && item.keywords.some(k => k.toLowerCase().includes(q))))
            : [...this.slashMenuItems];
    }

    private updateSlashMenuPosition() {
        if (!this.editor) return;
        const { view } = this.editor;
        const { from } = view.state.selection;
        const coords = view.coordsAtPos(from);
        const containerRect = this.editorContainer.nativeElement.getBoundingClientRect();
        this.slashMenuPos = {
            top: coords.bottom - containerRect.top + 4,
            left: coords.left - containerRect.left,
        };
    }

    private handleSlashKeydown(e: KeyboardEvent) {
        if (!this.slashMenuOpen) return;
        if (e.key === 'ArrowDown') {
            e.preventDefault();
            this.slashSelectedIndex = (this.slashSelectedIndex + 1) % this.slashFilteredItems.length;
            this.scrollSlashItemIntoView();
            this.cdr.detectChanges();
        } else if (e.key === 'ArrowUp') {
            e.preventDefault();
            this.slashSelectedIndex = (this.slashSelectedIndex - 1 + this.slashFilteredItems.length) % this.slashFilteredItems.length;
            this.scrollSlashItemIntoView();
            this.cdr.detectChanges();
        } else if (e.key === 'Enter') {
            e.preventDefault();
            if (this.slashFilteredItems.length > 0) {
                this.selectSlashItem(this.slashFilteredItems[this.slashSelectedIndex]);
            }
        } else if (e.key === 'Escape') {
            this.slashMenuOpen = false;
            this.cdr.detectChanges();
        }
    }

    private scrollSlashItemIntoView() {
        setTimeout(() => {
            const el = document.querySelector('.slash-menu-item.active');
            if (el) el.scrollIntoView({ block: 'nearest' });
        }, 0);
    }

    public selectSlashItem(item: SlashMenuItem) {
        if (!this.editor || !this.slashRange) return;
        this.editor.chain().focus().deleteRange(this.slashRange).run();
        if (item.title === '이미지') {
            this.uploadImage();
        } else if (item.title === '파일') {
            this.uploadFile();
        } else {
            item.command(this.editor);
        }
        this.slashMenuOpen = false;
        this.cdr.detectChanges();
    }

    /* ────────────────────────────────────────
       Bubble Menu (Text Selection Toolbar)
       ──────────────────────────────────────── */
    private handleBubbleMenu() {
        if (!this.editor || !this.editable) return;
        const { from, to, empty } = this.editor.state.selection;
        if (empty || from === to) {
            this.bubbleMenuOpen = false;
            this.colorPickerOpen = false;
            this.linkInputOpen = false;
            this.cdr.detectChanges();
            return;
        }
        const { view } = this.editor;
        const coords = view.coordsAtPos(from);
        const endCoords = view.coordsAtPos(to);
        const containerRect = this.editorContainer.nativeElement.getBoundingClientRect();
        this.bubbleMenuPos = {
            top: coords.top - containerRect.top - 48,
            left: ((coords.left + endCoords.left) / 2) - containerRect.left,
        };
        this.bubbleMenuOpen = true;
        this.cdr.detectChanges();
    }

    /* ────────────────────────────────────────
       Color Picker
       ──────────────────────────────────────── */
    public toggleColorPicker(event: Event, mode: 'text' | 'bg') {
        event.stopPropagation();
        if (this.colorPickerOpen && this.colorPickerMode === mode) {
            this.colorPickerOpen = false;
        } else {
            this.colorPickerMode = mode;
            this.colorPickerOpen = true;
        }
        this.linkInputOpen = false;
        this.cdr.detectChanges();
    }

    public setTextColor(color: string | null) {
        if (!this.editor) return;
        if (color) {
            this.editor.chain().focus().setColor(color).run();
        } else {
            this.editor.chain().focus().unsetColor().run();
        }
        this.colorPickerOpen = false;
        this.cdr.detectChanges();
    }

    public setBgColor(color: string | null) {
        if (!this.editor) return;
        if (color) {
            this.editor.chain().focus().toggleHighlight({ color }).run();
        } else {
            this.editor.chain().focus().unsetHighlight().run();
        }
        this.colorPickerOpen = false;
        this.cdr.detectChanges();
    }

    /* ────────────────────────────────────────
       Table Context Toolbar
       ──────────────────────────────────────── */
    private checkTableContext() {
        if (!this.editor || !this.editable) return;
        const isInTable = this.editor.isActive('table');
        if (isInTable) {
            this.updateTableMenuPosition();
            this.tableMenuOpen = true;
            this.cdr.detectChanges();
        } else if (this.tableMenuOpen) {
            this.tableMenuOpen = false;
            this.cdr.detectChanges();
        }
    }

    private updateTableMenuPosition() {
        if (!this.editor) return;
        const { view, state } = this.editor;
        const { from } = state.selection;
        const containerRect = this.editorContainer.nativeElement.getBoundingClientRect();
        try {
            const domAtPos = view.domAtPos(from);
            let el: HTMLElement = domAtPos.node as HTMLElement;
            if (el.nodeType === Node.TEXT_NODE) el = el.parentElement!;
            const tableWrapper = el.closest('.tableWrapper') as HTMLElement;
            const target = tableWrapper || el.closest('table') as HTMLElement;
            if (target) {
                const targetRect = target.getBoundingClientRect();
                this.tableMenuPos = {
                    top: targetRect.top - containerRect.top - 44,
                    left: targetRect.left - containerRect.left,
                };
                return;
            }
        } catch (_) { }
        const coords = view.coordsAtPos(from);
        this.tableMenuPos = {
            top: coords.top - containerRect.top - 44,
            left: coords.left - containerRect.left,
        };
    }

    public addRowBefore() { this.editor?.chain().focus().addRowBefore().run(); }
    public addRowAfter() { this.editor?.chain().focus().addRowAfter().run(); }
    public deleteRow() { this.editor?.chain().focus().deleteRow().run(); }
    public addColumnBefore() { this.editor?.chain().focus().addColumnBefore().run(); }
    public addColumnAfter() { this.editor?.chain().focus().addColumnAfter().run(); }
    public deleteColumn() { this.editor?.chain().focus().deleteColumn().run(); }
    public deleteTable() { this.editor?.chain().focus().deleteTable().run(); }
    public toggleHeaderRow() { this.editor?.chain().focus().toggleHeaderRow().run(); }
    public mergeCells() { this.editor?.chain().focus().mergeCells().run(); }
    public splitCell() { this.editor?.chain().focus().splitCell().run(); }

    /* ────────────────────────────────────────
       Formatting Commands
       ──────────────────────────────────────── */
    public toggleBold() { this.editor?.chain().focus().toggleBold().run(); }
    public toggleItalic() { this.editor?.chain().focus().toggleItalic().run(); }
    public toggleUnderline() { this.editor?.chain().focus().toggleUnderline().run(); }
    public toggleStrike() { this.editor?.chain().focus().toggleStrike().run(); }
    public toggleCode() { this.editor?.chain().focus().toggleCode().run(); }
    public toggleHighlight() { this.editor?.chain().focus().toggleHighlight().run(); }

    public setTextAlign(align: string) {
        this.editor?.chain().focus().setTextAlign(align).run();
    }

    public setHeading(level: number) {
        this.editor?.chain().focus().toggleHeading({ level: level as 1 | 2 | 3 }).run();
    }

    public isActive(name: string, attrs?: any): boolean {
        return this.editor?.isActive(name, attrs) || false;
    }

    /* ────────────────────────────────────────
       Link
       ──────────────────────────────────────── */
    public openLinkInput(event: Event) {
        event.stopPropagation();
        this.colorPickerOpen = false;
        const prev = this.editor?.getAttributes('link').href;
        this.linkInputUrl = prev || 'https://';
        this.linkInputOpen = true;
        this.cdr.detectChanges();
        setTimeout(() => {
            const input = document.querySelector('.link-input-field') as HTMLInputElement;
            if (input) { input.focus(); input.select(); }
        }, 50);
    }

    public applyLink() {
        if (!this.editor) return;
        const url = this.linkInputUrl.trim();
        if (!url || url === 'https://') {
            this.editor.chain().focus().unsetLink().run();
        } else {
            this.editor.chain().focus().extendMarkRange('link').setLink({ href: url }).run();
        }
        this.linkInputOpen = false;
        this.cdr.detectChanges();
    }

    public removeLink() {
        if (!this.editor) return;
        this.editor.chain().focus().unsetLink().run();
        this.linkInputOpen = false;
        this.cdr.detectChanges();
    }

    public handleLinkKeydown(e: KeyboardEvent) {
        if (e.key === 'Enter') {
            e.preventDefault();
            this.applyLink();
        } else if (e.key === 'Escape') {
            this.linkInputOpen = false;
            this.cdr.detectChanges();
        }
    }

    /* ────────────────────────────────────────
       Image / File Upload
       ──────────────────────────────────────── */
    public async uploadImage() {
        const files = await this.service.file.select({ accept: 'image/*' });
        if (!files || files.length === 0) return;
        await this.service.loading.show();
        for (const file of files) {
            const fd = new FormData();
            fd.append('upload', file);
            try {
                const res: any = await this.service.file.upload('/file/upload', fd, () => { });
                const url = res?.url;
                if (url && this.editor) {
                    this.editor.chain().focus().setImage({ src: url }).run();
                }
            } catch (e) {
                console.error('[notion-editor] Image upload failed:', e);
            }
        }
        await this.service.loading.hide();
    }

    public async uploadFile() {
        const files = await this.service.file.select();
        if (!files || files.length === 0) return;
        await this.service.loading.show();
        for (const file of files) {
            const fd = new FormData();
            fd.append('upload', file);
            try {
                const res: any = await this.service.file.upload('/file/upload', fd, () => { });
                const url = res?.url;
                if (url && this.editor) {
                    this.editor.chain().focus().insertContent({
                        type: 'fileAttachment',
                        attrs: { url, name: file.name, size: file.size },
                    }).run();
                }
            } catch (e) {
                console.error('[notion-editor] File upload failed:', e);
            }
        }
        await this.service.loading.hide();
    }

    /* ────────────────────────────────────────
       Helpers
       ──────────────────────────────────────── */
    public getSlashCategories(): string[] {
        const categories: string[] = [];
        for (const item of this.slashFilteredItems) {
            if (!categories.includes(item.category)) categories.push(item.category);
        }
        return categories;
    }

    public getItemsByCategory(category: string): SlashMenuItem[] {
        return this.slashFilteredItems.filter(item => item.category === category);
    }

    public getOverallIndex(item: SlashMenuItem): number {
        return this.slashFilteredItems.indexOf(item);
    }

    public getCurrentBlockType(): string {
        if (!this.editor) return '텍스트';
        if (this.editor.isActive('heading', { level: 1 })) return '제목 1';
        if (this.editor.isActive('heading', { level: 2 })) return '제목 2';
        if (this.editor.isActive('heading', { level: 3 })) return '제목 3';
        if (this.editor.isActive('bulletList')) return '글머리 기호';
        if (this.editor.isActive('orderedList')) return '번호 목록';
        if (this.editor.isActive('taskList')) return '할 일';
        if (this.editor.isActive('blockquote')) return '인용';
        if (this.editor.isActive('codeBlock')) return '코드';
        return '텍스트';
    }
}

export default PortalLpsysadminWidgetNotionEditorComponent;